export default class SaturnExpressionRequest {
	id?: string = null;
	name?: string = null;
	constructor(init: SaturnExpressionRequest) {
		if (init) {
			this.id = init.id;
			this.name = init.name;
		}
	}
}
